<template>
  <div style="background: black">
    <!--<v-card class="mt-6" style="padding: 20px">
      <v-row>
        <v-col cols="4" v-for="item in busStopList" :key="'bus' + item.id">
          <v-btn
            block
            x-large
            class="selectBtn"
            @touchstart="goClient(item.id)"
            >{{ item.name }}</v-btn
          >
        </v-col>

        <v-col cols="12" v-for="item in mobilityData" :key="'mobil' + item.id">
          <v-btn
            block
            x-large
            class="selectBtn"
            @touchstart="goDriver(item.id)"
            >{{ item.name }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card>-->
  </div>
</template>
<script>
import store from "../store";
import Export from "../export";
import router from "../vue-router/index";
export default {
  name: "Top",

  components: {},

  data: () => ({
    //
  }),
  async mounted() {
    var getBusStopSetId = await Export.getBusStopSetId();
    this.busStopSetId = getBusStopSetId.data[0].setId;
    var getBusStopList = await Export.getBusStopList(this.busStopSetId);
    this.busStopList = JSON.parse(getBusStopList.data[0].data);
    var getMobilityData = await Export.getMobilityData();
    this.mobilityData = getMobilityData.data;
    this.startUpTimestamp = Date.now();
    var currentBusStopId = this.getCookie("currentBusStopId");
    var currentMobilityId = this.getCookie("currentMobilityId");
    var driverMode = this.getCookie("driverMode");
    var homeLat = this.getCookie("homeLat");
    var homeLon = this.getCookie("homeLon");
    this.homeLat = homeLat;
    this.homeLon = homeLon;
    if (driverMode != null) {
      if (driverMode == "true") {
        this.driverMode = true;
      } else {
        this.driverMode = false;
      }
      if (this.driverMode == false && currentBusStopId != null) {
        this.currentBusStopId = currentBusStopId;
        //router.push("/standby");//エラー回避のため一旦コメントアウト
      }
      if (this.driverMode == true && currentMobilityId != null) {
        this.currentMobilityId = currentMobilityId;
        router.push("/driver");
      }
    }
    this.goClient(0);
  },
  computed: {
    currentBusStopId: {
      get() {
        return store.state.currentBusStopId;
      },
      set(value) {
        store.state.currentBusStopId = value;
      },
    },
    currentMobilityId: {
      get() {
        return store.state.currentMobilityId;
      },
      set(value) {
        store.state.currentMobilityId = value;
      },
    },
    driverMode: {
      get() {
        return store.state.driverMode;
      },
      set(value) {
        store.state.driverMode = value;
      },
    },
    busStopSetId: {
      get() {
        return store.state.busStopSetId;
      },
      set(value) {
        store.state.busStopSetId = value;
      },
    },
    busStopList: {
      get() {
        return store.state.busStopList;
      },
      set(value) {
        store.state.busStopList = value;
      },
    },
    mobilityData: {
      get() {
        return store.state.mobilityData;
      },
      set(value) {
        store.state.mobilityData = value;
      },
    },
    startUpTimestamp: {
      get() {
        return store.state.startUpTimestamp;
      },
      set(value) {
        store.state.startUpTimestamp = value;
      },
    },
    homeLat: {
      get() {
        return store.state.homeLat;
      },
      set(value) {
        store.state.homeLat = value;
      },
    },
    homeLon: {
      get() {
        return store.state.homeLon;
      },
      set(value) {
        store.state.homeLon = value;
      },
    },
  },
  methods: {
    goClient(num) {
      //cookie保存
      //this.$cookies.config(60 * 60 * 24 * 360, "");
      //this.$cookies.config(5, "");
      this.$cookies.set("currentBusStopId", num, 0);
      this.$cookies.set("driverMode", "false", 0);
      this.currentBusStopId = num;
      this.driverMode = false;
      router.push("/standby");
    },
    goDriver(num) {
      //cookie保存
      //this.$cookies.config(60 * 60 * 24 * 360, "");
      //this.$cookies.config(5, "");
      this.$cookies.set("currentMobilityId", num, 0);
      this.$cookies.set("driverMode", "true", 0);
      this.currentMobilityId = num;
      this.driverMode = true;
      router.push("/driver");
    },
    getCookie(key) {
      return this.$cookies.get(key);
    },
  },
};
</script>
<style>
.selectBtn {
  font-size: 30px !important;
  font-weight: bold !important;
  margin: 10px 0;
  height: 80px !important;
}
</style>
